import Icon, { COLORS } from '../../../../general-ui/icon';
import { SocialLink, Speaker } from '../../../../../types/working-model';
import { TypographyItem } from '../../../../general-ui/typography-item/typography-item';
import classNames from 'classnames';
import { TemplateClassNames } from '../../../../../types/template-layouts';
import { useParams } from 'react-router';
import { ParamsProps } from '../../../live-event';

interface ISpeakerCardProps {
	speaker: Speaker;
	template: TemplateClassNames;
	onClick?: (speaker: Speaker) => void;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const SpeakerCard: React.FC<ISpeakerCardProps> = ({ speaker, template, onClick }): JSX.Element => {

	const { language } = useParams() as ParamsProps;
	return (
		<div
			className="speaker"
			onClick={() => onClick?.(speaker)}
		>
			<img src={speaker.image} alt={speaker.first_name} />

			<div className="speaker-data">
				<TypographyItem
					className={classNames('speaker-name', {
						'evt-heading-3': template === TemplateClassNames.Apollo,
						'evt-heading-4': template !== TemplateClassNames.Classic,
					})}
					tagName="h3"
					template={template}
				>
					{speaker.first_name} {speaker.last_name}
				</TypographyItem>
				<TypographyItem
					className={classNames('speaker-job-title')}
					tagName="h5"
				>
					{speaker.job_title?.[language] ?? speaker.job_title?.base}
				</TypographyItem>
				<TypographyItem
					tagName="p"
					className="description"
					template={template}
				>
					{speaker.description?.[language] ?? speaker.description.base}
				</TypographyItem>
				<div className="social-links">
					{speaker.link_social && speaker.social_links?.map((link: SocialLink, i: number) => <a href={link.url} target="_blank" rel="noreferrer" key={link.url + i}><Icon name={link.platform} color={COLORS.ACCENT_BLUE} size={13} /></a>)}
				</div>
			</div>
		</div>
	);
};

export default SpeakerCard;
